import { perStepClosingRange } from '../constants/compound';
import { decomposeMillis } from './common';

export const isPerStepClosingRangeEnabled = (globalClosingRange) =>
  globalClosingRange.value === perStepClosingRange.value;

export const upToNowValue = 3153600000000;

export const getClosingRangeText = (closingRange) => {
  if (closingRange.value === 0) {
    return 'Not specified';
  }

  if (closingRange.value === upToNowValue) {
    return 'Up to now';
  }

  const { days, hours, minutes, seconds } = decomposeMillis(closingRange.value);

  return `
    ${days ? days + (days > 1 ? ' days ' : ' day ') : ''}
    ${hours ? hours + (hours > 1 ? ' hours ' : ' hour ') : ''}
    ${minutes ? minutes + (minutes > 1 ? ' minutes ' : ' minute ') : ''}
    ${seconds ? seconds + (seconds > 1 ? ' seconds ' : ' second ') : ''}
  `.trim();
};

export const formatClosingRange = (closingRange) => {
  if (closingRange.value === 0) {
    return 'Not specified';
  }

  if (closingRange.value === upToNowValue) {
    return 'Up to now';
  }

  const { days, hours, minutes, seconds } = decomposeMillis(closingRange.value);

  return {
    days: days ? days + (days > 1 ? ' days ' : ' day ') : '',
    hours: hours ? hours + (hours > 1 ? ' hours ' : ' hour ') : '',
    minutes: minutes ? minutes + (minutes > 1 ? ' minutes ' : ' minute ') : '',
    seconds: seconds ? seconds + (seconds > 1 ? ' seconds ' : ' second ') : '',
  };
};

export const isStepEnabled = (enabled) => enabled == null || enabled;

export const clearEmptyFilterClauses = (item) => {
  const filterEmptyFilterClauses = (step) => {
    const clauses = step?.filter.clauses;
    return clauses.filter((i) => !!i.field);
  };

  return {
    ...item,
    steps: item.steps.map((step) => ({
      ...step,
      optional:
        step.optional && item.steps.filter((a) => a.enabled).findIndex((s) => s === step) !== 0,
      filter: {
        ...step.filter,
        clauses: filterEmptyFilterClauses(step),
      },
    })),
  };
};

export const scrollToActiveElement = (
  set = { block: 'nearest', inline: 'nearest', behavior: 'smooth' }
) => {
  document.querySelector('.items').querySelector('.active').scrollIntoView(set);
};
